class NotifyMeForm extends HTMLElement {
	connectedCallback() {
		if (this._initialized) return;
		this._initialized = true;

		this.form = this.querySelector("form");
		this.button = this.querySelector('[type="submit"]');
		this.formBody = this.querySelector(".notify-me-form__body");
		this.successEl = this.querySelector(".notify-me-form__success");
		this.errorEl = this.querySelector(".notify-me-form__error");

		this.form.addEventListener("submit", this.onSubmit.bind(this));

		const modal = this.closest("basic-modal");
		if (modal) {
			modal.addEventListener("toggle", () => {
				if (modal.open) this.reset();
			});
		}
	}

	reset() {
		this.form.reset();
		this.formBody.hidden = false;
		this.successEl.hidden = true;
		this.errorEl.hidden = true;
	}

	async onSubmit(e) {
		e.preventDefault();

		const email = this.form.querySelector('[name="email"]').value.trim();
		const productHandle = this.dataset.productHandle;
		const endpoint = this.dataset.endpoint;

		this.button.disabled = true;
		this.button.classList.add("loading");
		this.errorEl.hidden = true;

		try {
			const res = await fetch(endpoint, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ email, productHandle }),
			});

			const data = await res.json();

			if (data.success) {
				this.formBody.hidden = true;
				this.successEl.hidden = false;
				this.successEl.focus();
			} else {
				this.errorEl.textContent =
					data.error || this.dataset.errorMessage;
				this.errorEl.hidden = false;
			}
		} catch {
			this.errorEl.textContent = this.dataset.errorMessage;
			this.errorEl.hidden = false;
		} finally {
			this.button.disabled = false;
			this.button.classList.remove("loading");
		}
	}
}

if (!customElements.get("notify-me-form")) {
	customElements.define("notify-me-form", NotifyMeForm);
}
